import FormattedMessage from 'I18n/components/FormattedMessage';
import { FeatureTable } from 'feature-monetization';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import Products from 'merchandise-lib/constants/Product';
import { CommerceHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/CommerceHubFaqs';
import { CommerceHubProductIcon } from 'pricing-pages-ui-components/productIcon/CommerceHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { getPrimaryTracker } from 'usage-tracker-container';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PaymentsProcessorsSectionWrapper from '../../components/commerce-hub/PaymentsProcessorsSectionWrapper';
import ViewPricingLink from '../../components/commerce-hub/ViewPricingLink';
import CalculatorAnchorLink from '../../components/CalculatorAnchorLink';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { useIsInAppAuth } from '../../hooks/user/useUserInfo';
import { trackClickedLink, trackFaqInteraction, trackPageView } from '../../utils/tracking/trackingEventUtils';
import { TRACKING_SOURCES } from '../../constants/tracking/TrackingSources';
import { CommerceHubFeatureTable } from './CommerceHubFeatureTable';
import { CommerceHubMerchCards } from './CommerceHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMMERCE_HUB_API_NAMES = [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE];
export const CommerceHubPage = () => {
  useDocumentTitle('commerce');
  const isInAppAuth = useIsInAppAuth();
  useEffect(() => {
    trackPageView({
      screen: 'commerce'
    });
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "COMMERCE_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "COMMERCE",
      apiNames: COMMERCE_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(CommerceHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.commerce.pageTitle"
        })]
      }), /*#__PURE__*/_jsxs(PageSubTitle, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.commerce.description"
        }), /*#__PURE__*/_jsx(ViewPricingLink, {}), /*#__PURE__*/_jsx(CalculatorAnchorLink, {
          defaultProductApiName: Products.COMMERCE_HUB_PROFESSIONAL
        })]
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CommerceHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "commerce"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: isInAppAuth ? /*#__PURE__*/_jsx(CardWrapper, {
        borderRadius: "300",
        borderWidth: "100",
        blockSize: "100%",
        marginBlock: "0",
        children: /*#__PURE__*/_jsx(CardSection, {
          children: /*#__PURE__*/_jsx(FeatureTable, {
            skuCategoryName: "COMMERCE_PRODUCTS",
            productApiNames: COMMERCE_HUB_API_NAMES,
            usageTracker: getPrimaryTracker()
          })
        })
      }) : /*#__PURE__*/_jsx(CommerceHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(PaymentsProcessorsSectionWrapper, {}), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "commerce"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CommerceHubFaqs, {
        onLinkClick: props => trackClickedLink(Object.assign({}, props, {
          trackingSource: TRACKING_SOURCES.FAQ
        })),
        onFaqInteraction: trackFaqInteraction
      })
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "commerce-footer",
      screen: "commerce",
      apiName: Products.COMMERCE_HUB_PROFESSIONAL
    })]
  });
};